import { render } from "./TaskTypes.vue?vue&type=template&id=386c1357"
import script from "./TaskTypes.vue?vue&type=script&lang=js"
export * from "./TaskTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__